import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.001 18.334a8.333 8.333 0 1 1 0-16.667 8.333 8.333 0 0 1 0 16.667m0-1.667a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333m0-7.845 2.357-2.357 1.179 1.178L11.18 10l2.357 2.357-1.179 1.179-2.357-2.357-2.357 2.357-1.178-1.179L8.823 10 6.466 7.643l1.178-1.178z"
    }, null, -1)
  ]))]))
}
export default { render: render }